<script lang="ts">
  import { base } from "$app/paths";
  import GoogleAdSense from "$components/adSense/googleAdSense.svelte";
  import { t } from "$lib/i18n/translations";
  import { page } from "$app/stores";
  import { isMobile } from "$lib/device";
  import CardVideo from "../icons/CardVideo.svelte"
  import CardHd from "../icons/CardHd.svelte"
  import CardMp3 from "../icons/CardMp3.svelte"
  import CardLongVideo from "../icons/CardLongVideo.svelte"
  import CardStory from "../icons/CardStory.svelte"
  import CardReel from "../icons/CardReel.svelte"
  import { WEB_SHOW_ADSENCE }from "$env/static/public";
  let pageName = "";
  const aboutCardList = [
    {
      title: "general.about.card1.title",
      description: "general.about.card1.description",
      image: CardVideo,
      bgColor: "#FFE5EECC",
    },
    {
      title: "general.about.card2.title",
      description: "general.about.card2.description",
      image: CardHd,
      bgColor: "#F1F1FCCC",
    },
    {
      title: "general.about.card3.title",
      description: "general.about.card3.description",
      image: CardMp3,
      bgColor: "#FFF8E6CC",
    },
    {
      title: "general.about.card4.title",
      description: "general.about.card4.description",
      image: CardLongVideo,
      bgColor: "#FFF8E6CC",
    },
    {
      title: "general.about.card5.title",
      description: "general.about.card5.description",
      image: CardStory,
      bgColor: "#E1FBF3CC",
    },
    {
      title: "general.about.card6.title",
      description: "general.about.card6.description",
      image: CardReel,
      bgColor: "#EBF3FFCC",
    },
  ];

  const tagMap = [
    { value: "video", label: "tabs.video" },
    { value: "photo", label: "tabs.photo" },
    { value: "reels", label: "tabs.reels" },
    { value: "story", label: "tabs.story" },
    { value: "post", label: "tabs.post" },
    { value: "igtv", label: "tabs.igtv" },
    { value: "highlights", label: "tabs.highlights" },
  ]; 
  $: {
    const pathEnd = $page.url.pathname.split("/").pop() || "";
    const value = pathEnd.includes("-") ? pathEnd.split("-")[1] : pathEnd;
    pageName = tagMap.find((item) => item.value == value)?.label || "";
  }
</script>

<!-- 内容介绍 -->
<section class="w-full bg-white">
  <div
    class="max-w-[1312px] mx-auto w-full w-full flex flex-col items-center justify-center px-[16px]"
  >
    <!-- 标题 -->
    <div class="mt-[100px] text-center max-w-[1000px] max-mobile:mt-[40px]">
      <h2
        class="!text-[36px] !font-bold !leading-normal !mb-4 max-mobile:!mb-3 max-mobile:!text-[20px] px-[30px]"
      >
        {$t("general.about.title", { value: $t(pageName) })}
      </h2>
      <p
        class="text-[18px] leading-normal text-[#808080] max-mobile:text-[14px]"
      >
        {$t("general.about.description")}
      </p>
    </div>
    <!-- 卡片 -->
    <div class="mt-11 mb-[100px] max-mobile:mt-[16px] max-mobile:mb-[80px]">
      <div
        class="grid grid-cols-3 gap-5 gap-y-20 text-center max-mobile:grid-cols-1 max-mobile:gap-4"
      >
        {#each aboutCardList as item, i}
          <article
            style={`background:${item.bgColor}`}
            class="{i < 3
              ? 'rounded-tl-[16px] rounded-tr-[16px] rounded-bl-[48%] rounded-br-[48%]'
              : 'rounded-bl-[16px] rounded-br-[16px] rounded-tl-[48%] rounded-tr-[48%]'}
              w-full h-[480px] px-15 pt-13 flex flex-col items-center bg-red-100
              max-mobile:rounded-[12px]
              max-mobile:px-4
              max-mobile:py-8
              max-mobile:h-[350px]"
          >
            <div class="w-[46px] h-[46px] mb-5">
                <svelte:component this={item.image} />
            </div>
            <h3
              class="!text-[24px] !mb-4 !font-bold !leading-[1.25] max-mobile:!text-[16px] max-mobile:!mb-2"
            >
              {$t(item.title)}
            </h3>
            <div class="text-[18px]">
              {$t(item.description)}
            </div>
          </article>
        {/each}
      </div>
    </div>
    <!-- 广告 -->
    <div class="mb-[60px] w-full max-w-[1100px] max-mobile:mb-0">
      <GoogleAdSense type="crosswise"/>
    </div>
  </div>
</section>

<!-- 使用说明 -->
<section class="w-full bg-[#EAF0FD]">
  <div
    class="max-w-[1312px] mx-auto w-full w-full flex flex-col items-center justify-center max-mobile:px-[16px]"
  >
    <!-- 标题 -->
    <div
      class="mt-[100px] mb-[50px] text-center max-w-[1000px] max-mobile:mt-[60px]"
    >
      <h2
        class="!text-[36px] !font-bold !leading-normal !mb-4 max-mobile:!mb-3 max-mobile:!text-[20px] max-mobile:px-[30px]"
      >
        {$t("general.about.title")}
      </h2>
      <p
        class="text-[18px] leading-normal text-[#808080] max-mobile:text-[14px]"
      >
        {$t("general.about.description")}
      </p>
    </div>
    <div
      class="mt-11 mb-[100px] grid grid-cols-2 max-w-[1000px] rounded-[16px] border-[3px] border-[#ffffff] h-[800px]
        max-mobile:grid-cols-1
        max-mobile:rounded-none
        max-mobile:border-none
        max-mobile:mt-0
        max-mobile:h-auto
      "
    >
      <!-- 卡片 -->
      <div
        class="w-full row-start-1 row-end-2 max-mobile:row-start-2 max-mobile:row-end-3 max-mobile:mt-6"
      >
        <img
          src="{base}/images/instructions-copy.png"
          alt="{$t("general.instructions.steps.step1")}:{$t("general.instructions.steps.step1.title")}"
          class="h-full w-full rounded-tl-[10px] max-mobile:rounded-[8px]"
          loading="lazy"
        />
      </div>
      <div
        class="w-full pl-[50px] flex flex-col justify-center items-start row-start-1 row-end-2 bg-[#F1F5FD] rounded-tr-[16px]
        max-mobile:row-start-1 max-mobile:row-end-2 max-mobile:pl-0 max-mobile:items-center max-mobile:text-center max-mobile:bg-transparent
        "
      >
        <div class="flex justify-start items-center max-mobile:justify-center">
          <img
            src="{base}/icons/instructions-dot.png"
            alt="instructions-dot"
            class="w-[14px] h-[14px]"
            loading="lazy"
          />
          <div class="ml-4 instructions-title text-[20px] max-mobile:ml-2">
            {$t("general.instructions.steps.step1")}
          </div>
        </div>
        <h3
          class="!text-[32px] !font-bold !leading-normal !mt-8 !mr-[80px]
          max-mobile:!text-[16px] max-mobile:!mr-0 max-mobile:!mt-6"
        >
          {$t("general.instructions.steps.step1.title")}
        </h3>
        <p
          class="text-[18px] leading-normal mt-6 mr-[80px]
          max-mobile:text-[16px] max-mobile:mt-3 max-mobile:mr-0"
        >
          {$t("general.instructions.steps.step1.description")}
        </p>
      </div>
      <div
        class="w-full pl-[50px] flex flex-col justify-center items-start row-start-2 row-end-3 bg-[#F1F5FD] rounded-bl-[16px]
        max-mobile:row-start-3 max-mobile:row-end-4 max-mobile:pl-0 max-mobile:items-center max-mobile:text-center max-mobile:mt-[40px] max-mobile:bg-transparent
        "
      >
        <div class="flex justify-start items-center max-mobile:justify-center">
          <img
            src="{base}/icons/instructions-dot.png"
            alt="instructions-dot"
            class="w-[14px] h-[14px]"
            loading="lazy"
          />
          <div class="ml-4 instructions-title text-[20px] max-mobile:ml-2">
            {$t("general.instructions.steps.step2")}
          </div>
        </div>
        <h3
          class="!text-[32px] !font-bold !leading-normal !mt-8 !mr-[60px]
          max-mobile:!text-[16px] max-mobile:!mr-0 max-mobile:!mt-6"
        >
          {$t("general.instructions.steps.step2.title")}
        </h3>
        <p
          class="text-[18px] leading-normal mt-6 mr-[100px]
          max-mobile:text-[16px] max-mobile:mt-3 max-mobile:mr-0"
        >
          {$t("general.instructions.steps.step2.description")}
        </p>
      </div>
      <div
        class="w-full row-start-2 row-end-3 max-mobile:row-start-4 max-mobile:row-end-5 max-mobile:mt-6"
      >
        <img
          src="{base}/images/instructions-pause.png"
          alt="{$t("general.instructions.steps.step2")}:{$t("general.instructions.steps.step2.title")}"
          class="h-full w-full rounded-br-[10px] max-mobile:rounded-[8px]"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</section>

<!-- 选品 -->
<section class="w-full">
  <div
    class="max-w-[1312px] mx-auto w-full w-full flex gap-[30px] items-center justify-center relative py-[120px] px-[24px]
    max-mobile:py-[60px]
    max-mobile:px-[16px]
    max-mobile:gap-[24px]
    max-mobile:flex-col
    "
  >
    <div
      class="absolute top-[128px] left-[24px] h-[8px] w-[40px] bg-black z-0 max-mobile:hidden"
    ></div>
    <h2
      class="!text-[44px] w-[350px] !leading-[1.75] !font-bold shrink-0 relative z-1 max-mobile:!text-[20px] max-mobile:w-full max-mobile:px-[4px] max-mobile:text-center"
    >
      {$t("general.selection.title")}
    </h2>
    <div
      class="grid grid-cols-2 grid-rows-[auto_auto] relative grow-1 gap-[26px] leading-normal relative z-1 max-mobile:gap-[16px]"
    >
      <div
        class="w-full h-full col-span-2 bg-[#A5B5FB] rounded-[16px] pt-[72px] pb-[60px] px-[35px] relative
        max-mobile:px-[24px] max-mobile:pt-[24px] max-mobile:pb-[24px]"
      >
        <img
          class="absolute top-[35px] left-[35px] z-0 w-[100px] max-mobile:hidden"
          src="{base}/icons/01-icon.png"
          alt="icon"
          loading="lazy"
        />
        <h3 class="!text-[30px] !font-bold relative max-mobile:!text-[20px]">
          {$t("general.selection.card1.title")}
        </h3>
        <p class="text-[18px] mt-[26px] relative">
          {$t("general.selection.card1.description")}
        </p>
      </div>
      <div
        class="w-full h-full bg-[#87DBFF] rounded-[16px] pt-[72px] pb-[60px] px-[35px] relative
        max-mobile:col-span-2 max-mobile:px-[24px] max-mobile:pt-[24px] max-mobile:pb-[24px]"
      >
        <img
          class="absolute top-[35px] left-[35px] z-0 w-[100px] max-mobile:hidden"
          src="{base}/icons/02-icon.png"
          alt="icon"
          loading="lazy"
        />
        <h3 class="!text-[30px] !font-bold relative max-mobile:!text-[20px]">
          {$t("general.selection.card2.title")}
        </h3>
        <p class="text-[18px] mt-[26px] relative">
          {$t("general.selection.card2.description")}
        </p>
      </div>
      <div
        class="w-full h-full bg-[#FA9DCC] rounded-[16px] pt-[72px] pb-[60px] px-[35px] relative
        max-mobile:col-span-2 max-mobile:px-[24px] max-mobile:pt-[24px] max-mobile:pb-[24px]"
      >
        <img
          class="absolute top-[35px] left-[35px] z-0 w-[100px] max-mobile:hidden"
          src="{base}/icons/03-icon.png"
          alt="icon"
          loading="lazy"
        />
        <h3 class="!text-[30px] !font-bold relative max-mobile:!text-[20px]">
          {$t("general.selection.card3.title")}
        </h3>
        <p class="text-[18px] mt-[26px] relative">
          {$t("general.selection.card3.description")}
        </p>
      </div>
    </div>
    <div
      class="absolute bottom-[192px] left-[180px] bg-[#fa9dcce0] w-[190px] h-[190px] bg-[#fa9dcc] blur-[92px] rounded-full z-0 max-mobile:hidden"
    ></div>
  </div>
  {#if !$isMobile && WEB_SHOW_ADSENCE === "true" }
    <!-- 广告 -->
    <div
      class="max-w-[1280px] mx-auto w-full w-full grid grid-cols-2 mb-[120px]"
    >
      <GoogleAdSense />
      <GoogleAdSense />
    </div>
  {/if}
</section>

<style>
  .instructions-title {
    background: linear-gradient(0deg, #f84095, #f84095),
      linear-gradient(90deg, #ff2b73 0%, #ff6c35 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
</style>
